/**
 * Universal Image Upload Module
 * Универсальный модуль для обработки загрузки и отображения превью изображений
 * Работает с avatar-upload и gallery-upload-item компонентами
 */
class ImageUpload {
  constructor(element) {
    this.element = element;
    this.input = element.querySelector('.image-upload__input');
    this.image = element.querySelector('.image-upload__image');
    this.emptySlot = element.querySelector('.image-upload__empty');
    this.wrapper = element.querySelector('.image-upload__wrapper');
    this.editButton = element.querySelector('.image-upload__edit');
    this.isGallery = element.classList.contains('gallery-upload-item');
    this.isAvatar = element.classList.contains('avatar-upload');
    this.init();
  }

  init() {
    if (!this.input) {
      return;
    }

    this.input.addEventListener('change', e => {
      this.handleFileSelect(e);
    });

    // Для элементов с изображением добавляем обработчик на кнопку редактирования
    if (this.editButton) {
      this.editButton.addEventListener('click', e => {
        e.preventDefault();
        this.input.click();
      });
    }
  }

  handleFileSelect(event) {
    const file = event.target.files[0];

    if (!file) {
      return;
    }

    // Проверка типа файла
    if (!file.type.startsWith('image/')) {
      alert('Please select an image file');
      return;
    }

    // Проверка размера файла (макс 5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('Image size should be less than 5MB');
      return;
    }

    // Создание FileReader для чтения файла
    const reader = new FileReader();

    reader.onload = e => {
      // Если это пустой слот, создаем wrapper с изображением
      if (this.emptySlot) {
        this.createImageWrapper(e.target.result);
      } else if (this.image) {
        // Если изображение уже есть, обновляем его
        this.image.src = e.target.result;
        this.image.style.display = 'block';
      }
    };

    reader.onerror = () => {
      alert('Error reading file');
    };

    // Чтение файла как Data URL
    reader.readAsDataURL(file);
  }

  createImageWrapper(imageSrc) {
    // Создаем структуру с изображением и иконкой редактирования
    const wrapper = document.createElement('div');
    wrapper.className = 'image-upload__wrapper';

    const img = document.createElement('img');
    img.className = 'image-upload__image';
    img.src = imageSrc;
    img.alt = this.isAvatar ? 'Avatar' : 'Gallery image';

    const label = document.createElement('label');
    label.className = this.isGallery ? 'image-upload__edit gallery--edit' : 'image-upload__edit';
    label.setAttribute('for', this.input.id);
    label.setAttribute('aria-label', this.isAvatar ? 'Edit avatar' : 'Edit image');

    const icon = document.createElement('i');
    icon.className = 'fal fa-edit';

    label.appendChild(icon);
    wrapper.appendChild(img);
    wrapper.appendChild(label);

    // Заменяем empty slot на wrapper с изображением
    this.emptySlot.parentNode.replaceChild(wrapper, this.emptySlot);

    // Обновляем ссылки
    this.wrapper = wrapper;
    this.image = img;
    this.editButton = label;
    this.emptySlot = null;

    // Добавляем обработчик для нового label
    label.addEventListener('click', e => {
      e.preventDefault();
      this.input.click();
    });
  }
}

// Auto-initialize on DOM load
document.addEventListener('DOMContentLoaded', () => {
  // Инициализируем avatar upload компоненты
  const avatarUploads = document.querySelectorAll('.avatar-upload');
  avatarUploads.forEach(upload => {
    new ImageUpload(upload);
  });

  // Инициализируем gallery upload компоненты
  const galleryItems = document.querySelectorAll('.gallery-upload-item');
  galleryItems.forEach(item => {
    new ImageUpload(item);
  });
});

export default ImageUpload;

